'use strict';

require('../../style/index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/icon/style/css.js
// module id = C8OZ
// module chunks = 0